<div class="modal-body">
  <div class="row">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <p class="header-text poppins">CREATE PLAYER</p>
      <img src="assets/img/shared/close-icon.svg" class="close-icon pointer" alt="" (click)="close()">
    </div>
    <div class="col-12">
      <p class="sub-text poppins">Please enter details of players</p>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input matInput formControlName="username">
          <mat-label>Username</mat-label>
        </mat-form-field>
      </div>
    </div>
    <div class="row mt-20">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input matInput formControlName="playerName">
          <mat-label>Player Name</mat-label>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <button class="btn submit poppins" type="button" (click)="confirm()" [disabled]="!form.valid">Submit</button>  
      </div>
    </div>
  </form>
</div>